<template>
  <b-modal :id="id" :title="id" size="xl" lazy centered
           body-class="w-100" hide-header hide-footer @show="load">
    <template #default>
      <b-overlay :show="true" bg-color="white" opacity="1" style="min-height: 100px;">
        <template v-if="!studentEvents.loading">
          <div v-for="hotel in hotels" :key="hotel.id" class="d-none d-print-block">
            <b-table-simple v-for="(group, index) in groups" :key="index" caption-top responsive>
              <caption>
                <div class="d-flex justify-content-center gap-1">
                  <b-img :src="logo" alt="Logo" class="print-logo" style="max-width: 74px;"/>
                  <div class="text-body d-flex flex-column align-self-center">
                    <div class="font-weight-bold font-large-1">Sign In</div>
                    <div class="font-weight-bold font-medium-1">All-State - {{ $store.getters['settings/getCurrentYear'] }}</div>
                  </div>
                </div>
              </caption>
              <b-thead>
                <b-tr>
                  <b-th colspan="4" class="font-weight-bolder font-medium-1 py-0 align-top">
                    <b-row no-gutters>
                      <b-col cols="auto" class="font-weight-bolder font-medium-1 py-0 align-top" :class="{ 'text-danger': !hotel.name }">
                        {{ hotel.name ? hotel.name : 'Unnamed Hotel' }}
                      </b-col>
                      <b-col class="font-weight-bolder font-small-4 py-0 align-top text-center">
                        <template v-if="filters.ensemble && filters.ensemble.length">
                          Ensemble{{ filters.ensemble.length > 1 ? 's' : '' }}: {{ filters.ensemble.map((id) => getEnsembleName(id)).join(', ') }}
                        </template>
                      </b-col>
                      <b-col cols="auto" class="font-weight-bolder font-medium-1 text-right py-0 align-top">
                        {{ group.from }} - {{ group.to }}
                      </b-col>
                    </b-row>
                  </b-th>
                </b-tr>
                <b-tr>
                  <b-th class="pb-2" colspan="4">{{ getStudentEventsByGrouping(hotel.id, group).length }} Students</b-th>
                </b-tr>
                <b-tr>
                  <b-th class="col-3">Student</b-th>
                  <b-th class="col-1" style="min-width: 75px;">Room</b-th>
                  <b-th class="col-5">School</b-th>
                  <b-th class="col-3">Signature</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="event in getStudentEventsByGrouping(hotel.id, group)" :key="event.id"
                      :data="application = event.student ? getApplicationWithSelection(event.student.applications) : null">
                  <b-td class="py-1">
                    <span v-if="event.student">
                      {{ getFullName(event.student, {lnf: true}) }}
                    </span>
                    <span v-else class="text-danger">
                    No Student
                  </span>
                  </b-td>
                  <b-td class="py-1">
                    <span v-if="event.room">
                       {{ event.room }}
                    </span>
                    <span v-else class="text-danger">
                    No Room
                  </span>
                  </b-td>

                  <b-td class="py-1">
                    <span v-if="event.student && event.student.school">
                       {{ event.student.school.name.legal }}
                    </span>
                    <span v-else class="text-danger">
                    Unknown School
                    </span>
                  </b-td>
                  <b-td class="py-1">
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </template>
        <b-card class="shadow-none m-0 p-0 d-print-none">
          <b-card-body>
            <!-- Card needed to give overlay some dimension -->
          </b-card-body>
        </b-card>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import PageLayout from '@/components/PageLayout.vue';


import notify from '@/mixins/notify.mixin';
import OverlayLoading from '@/components/OverlayLoading.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ApplicationDetails from '@/views/all-state/application/ApplicationDetails.vue';
import ApplicationStudent from '@/views/all-state/application/ApplicationStudent.vue';
import ApplicationQuestions from '@/views/all-state/application/ApplicationQuestions.vue';
import ApplicationGrading from '@/views/all-state/application/ApplicationGrading.vue';
import popper from '@/mixins/popper.mixin';
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';
import TableRowOptions from '@/components/TableRowOptions.vue';
import settingsMixin from '@/mixins/settings.mixin';
import {getStudentEvents, RegistrationGroup } from '@/views/events/service';
import events from '@/mixins/event.mixin';

export default {
  name: 'RegistrationSignInModal',
  components: {
    TableRowOptions,
    BCardActions,
    ApplicationGrading,
    ApplicationDetails,
    ApplicationStudent,
    ApplicationQuestions,
    OverlayLoading,
    PageLayout,
    vSelect,
    VuePerfectScrollbar
  },
  mixins: [notify, popper, settingsMixin, events],
  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    hotels: {
      type: Array,
      required: true,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      logo: null,
      studentEvents: {
        loading: true,
        items: [],
      },
      icon: 'fas fa-check',
    }
  },
  computed: {
    ensembles() {
      if(!this.studentEvents?.items?.length) return []
      const ensembles = this.studentEvents.items.map(i => {
        const application = this.getApplicationWithSelection(i.student.applications);
        return application?.selection?.ensemble;
      })
      return ensembles
        .filter((ensemble, index) => ensemble && ensembles.findIndex(i => i.id === ensemble.id) === index)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  watch: {
    events: {
      deep: true,
      handler(value) {
        this.studentEvents.items = value
        if(!this.groups.length) {
          this.groups.push(new RegistrationGroup('A', 'Z'))
        }
      }
    },
  },
  mounted() {
    window.addEventListener('afterprint', this.handleAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.handleAfterPrint);
  },
  methods: {
    async refresh() {
      await this.listStudentEvents()
    },
    async load() {
      if (!this.events.length) {
        await this.listStudentEvents()
      }
      else {
        this.studentEvents.items = this.events
        this.studentEvents.loading = false
      }

      if (!this.logo) {
        // eslint-disable-next-line global-require
        this.logo = require('@/assets/images/logo/logo5-blue-white-gold.svg');
      }

      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 500);
      })
    },

    handleAfterPrint() {
      this.$bvModal.hide(this.id)
    },

    async listStudentEvents() {
      this.studentEvents.loading = true;
      await getStudentEvents( { includeStudentSchool: true }).then(students => {
        this.studentEvents.items = students.sort((a, b) => {
          const roomA = a.room ? a.room : '99999'
          const roomB = b.room ? b.room : '99999'

          const nameA = a.student ? this.getFullName(a.student, {lnf: true}) : ''
          const nameB = b.student ? this.getFullName(b.student, {lnf: true}) : ''

          return nameA.localeCompare(nameB)
        })
        this.studentEvents.loading = false;
        this.studentEvents.loaded = true;
      })
    },

    getStudentEventsByGrouping(hotelId, group) {
      return this.studentEvents.items
          .filter(studentEvent => studentEvent.hotelId === hotelId)
          ?.filter(studentEvent => {
            const application = this.getApplicationWithSelection(studentEvent?.student?.applications)
            return !(this.filters?.ensemble?.length && !this.filters.ensemble.includes(application?.selection?.ensemble?.id));
          })
          .sort((a, b) => {
            const nameA = a.student ? this.getFullName(a.student, { lnf: true }) : '';
            const nameB = b.student ? this.getFullName(b.student, { lnf: true }) : '';
            return nameA.localeCompare(nameB);
          })
          .filter(studentEvent => {
            const lastName = studentEvent.student ? studentEvent.student.name.last.toUpperCase() : '';
            const from = group.from.toUpperCase();
            const to = group.to.toUpperCase();

            // Compare directly between the full "from" and "to" values
            return lastName.localeCompare(from) >= 0 && lastName.localeCompare(to) <= 0;
          });
    },

    getEnsembleName(id) {
      return this.ensembles.find(e => e.id === id)?.name || 'Unknown'
    },
    isFiltered() {
      return this.filters?.ensemble?.length
    },
  }
}
</script>

<style lang="scss">
@media print {
  .print-logo {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    vertical-align: middle;
  }

  #app {
    visibility: hidden;
    display: none;
  }

  table.b-table {
    page-break-after: always;
    break-after: page;

    * {
      font-size: 11px;
    }

    caption {
      display: table-caption;
      margin: 0 auto 2rem auto;
    }

    thead {
      page-break-before: unset !important;
      page-break-inside: unset !important;
      page-break-after: unset !important;
    }
  }

  .modal {
    padding-left: 0 !important;
    position: relative;

    .modal-dialog {
      width: 100vw;
      max-width: none;
      margin: 0;

      span[tabindex] {
        visibility: hidden;
        display: none;
      }

      .modal-content {
        height: 100%;
        border: 0;

        .modal-body {
          overflow-y: visible;

          .b-overlay-wrap {
            overflow: hidden;

            .b-overlay {
              visibility: hidden;
              display: none;
            }
          }
        }
      }

      .modal-footer {
        visibility: hidden;
        display: none;
      }
    }
  }

  .modal-backdrop {
    visibility: hidden;
    display: none;
  }
}
</style>


